import { secureGet } from "../../Config/ApiConfig";

export const getStats = async () => {
    const {data} = await secureGet('/statistics');
    return data
};


